var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 0.25C1.02974 0.25 0 1.27974 0 2.55V17.45C0 18.7203 1.02974 19.75 2.3 19.75H23.7C24.9703 19.75 26 18.7203 26 17.45V2.55C26 1.27974 24.9703 0.25 23.7 0.25H2.3ZM11.5 3.25H14.5V6.25H11.5V3.25ZM11.5 8.25H14.5V17.25H11.5V8.25Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e9cb2070e1812c08ca54ca7d501f8385.svg";
export { ForwardRef as ReactComponent };